import { render, staticRenderFns } from "./Mentors.vue?vue&type=template&id=f853f892&"
import script from "./Mentors.vue?vue&type=script&lang=js&"
export * from "./Mentors.vue?vue&type=script&lang=js&"
import style0 from "./Mentors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports